export function buildMailComposePath({
  to = "",
  prospectId = "",
  subject = "",
  body = "",
} = {}) {
  const params = new URLSearchParams();

  params.set("compose", "1");

  if (to) {
    params.set("to", to);
  }

  if (prospectId) {
    params.set("prospectId", prospectId);
  }

  if (subject) {
    params.set("subject", subject);
  }

  if (body) {
    params.set("body", body);
  }

  return `/app/mail?${params.toString()}`;
}
